import { Component, ContentChild, HostBinding, OnInit } from '@angular/core';
import { FormInputDirective } from './input.directive';
import { ERROR_MESSAGES } from './form-field-errors.config';
import { fadeAnimation } from '../../animations';
import { environment } from 'src/environment/environment.development';

/**
 * A component that represents a form field, which includes a label and an input control.
 * This component is designed to work with the `FormInputDirective` directive.
 */
@Component({
  selector: 'app-form-field',
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.scss'],
  animations: [fadeAnimation],
})
export class FormFieldComponent implements OnInit {
  @ContentChild(FormInputDirective, { static: true })
  public formInpuDirective!: FormInputDirective;

  @HostBinding('class.has-error')
  get hasError(): boolean {
    return !!this.errorMessage;
  }

  /**
   * Returns an object containing the error message key and options for the first error
   * found in the form input control. Returns null if no errors are found or if the control
   * has not been touched.
   *
   * @returns An object containing the error message key and options, or null if no errors
   * are found or if the control has not been touched.
   */
  get errorMessage(): { key: string; options: any } | null {
    const errors = Object.entries(
      this.formInpuDirective?.ngControl?.control?.errors || {}
    );
    const patternError = errors.find(el => el.includes('pattern'));

    if (!errors.length || !this.isControlTouched) {
      return null;
    }

    if (
      patternError &&
      patternError[1]?.requiredPattern === environment.emailPattern
    ) {
      return {
        key: ERROR_MESSAGES['email'],
        options: patternError[1],
      };
    }

    const [key, value] = errors[0];

    return {
      key: ERROR_MESSAGES[key],
      options: value,
    };
  }

  /**
   * Returns a boolean indicating whether the form input control has been touched or not.
   * @returns A boolean indicating whether the form input control has been touched or not.
   */
  get isControlTouched(): boolean | undefined {
    return this.formInpuDirective.ngControl.control?.touched;
  }

  public ngOnInit() {
    if (!this.formInpuDirective) {
      throw new Error('FormInputDirective is required!');
    }
  }
}
